<script setup>
import { ref } from 'vue';

const emit = defineEmits(['confirm', 'cancel']);

const scheduledDate = ref('');
const scheduledTime = ref('');
const error = ref('');

// Set default to tomorrow at current time rounded to next hour
const now = new Date();
const tomorrow = new Date(now);
tomorrow.setDate(tomorrow.getDate());
tomorrow.setMinutes(0);
tomorrow.setHours(tomorrow.getHours() + 1);
scheduledDate.value = tomorrow.toISOString().split('T')[0];
scheduledTime.value = tomorrow.toTimeString().slice(0, 5);

function confirm() {
  if (!scheduledDate.value || !scheduledTime.value) {
    error.value = 'Selecione data e hora';
    return;
  }
  const datetime = new Date(`${scheduledDate.value}T${scheduledTime.value}`);
  if (datetime <= new Date()) {
    error.value = 'A data deve ser no futuro';
    return;
  }
  emit('confirm', datetime.toISOString());
}
</script>

<template>
  <Teleport to="body">
    <div class="sz-sched-overlay" @click.self="emit('cancel')">
      <div class="sz-sched-modal">
        <div class="sz-sched-header">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
          </svg>
          <span>Agendar mensagem</span>
          <button class="sz-sched-close" @click="emit('cancel')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          </button>
        </div>
        <div class="sz-sched-body">
          <p class="sz-sched-desc">Escolha quando a mensagem será enviada:</p>
          <div class="sz-sched-fields">
            <div class="sz-sched-field">
              <label>Data</label>
              <input v-model="scheduledDate" type="date" />
            </div>
            <div class="sz-sched-field">
              <label>Hora</label>
              <input v-model="scheduledTime" type="time" />
            </div>
          </div>
          <div v-if="error" class="sz-sched-error">{{ error }}</div>
        </div>
        <div class="sz-sched-footer">
          <button class="sz-sched-btn-cancel" @click="emit('cancel')">Cancelar</button>
          <button class="sz-sched-btn-confirm" @click="confirm">Agendar</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.sz-sched-overlay {
  position: fixed; inset: 0; z-index: 99999; display: flex; align-items: center; justify-content: center;
  background: rgba(0,0,0,0.5); backdrop-filter: blur(4px);
}
.sz-sched-modal {
  width: 400px; max-width: 95vw; background: #fff; border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2); font-family: Inter, system-ui, sans-serif; overflow: hidden;
}
.sz-sched-header {
  display: flex; align-items: center; gap: 10px; padding: 16px 20px; border-bottom: 1px solid #E5E7EB;
  font-weight: 600; font-size: 16px; color: #1a1a1a;
}
.sz-sched-header svg { color: #388E3C; flex-shrink: 0; }
.sz-sched-close { margin-left: auto; border: none; background: none; cursor: pointer; color: #9CA3AF; display: flex; }
.sz-sched-body { padding: 20px; }
.sz-sched-desc { font-size: 14px; color: #525252; margin: 0 0 16px; }
.sz-sched-fields { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.sz-sched-field { display: flex; flex-direction: column; gap: 4px; }
.sz-sched-field label { font-size: 13px; font-weight: 500; color: #374151; }
.sz-sched-field input {
  padding: 10px 12px; border-radius: 8px; border: 1px solid #E5E7EB; font-size: 14px; color: #1a1a1a;
  background: #fff; outline: none; width: 100%; box-sizing: border-box;
}
.sz-sched-field input:focus { border-color: #388E3C; box-shadow: 0 0 0 3px rgba(56,142,60,0.1); }
.sz-sched-error { margin-top: 12px; padding: 8px 12px; border-radius: 8px; background: #fef2f2; color: #dc2626; font-size: 13px; }
.sz-sched-footer { display: flex; justify-content: flex-end; gap: 10px; padding: 16px 20px; border-top: 1px solid #E5E7EB; }
.sz-sched-btn-cancel { padding: 8px 16px; border: 1px solid #D4D4D4; border-radius: 8px; background: transparent; font-weight: 500; font-size: 14px; color: #374151; cursor: pointer; }
.sz-sched-btn-cancel:hover { background: #f5f5f5; }
.sz-sched-btn-confirm { padding: 8px 16px; border: none; border-radius: 8px; background: #388E3C; font-weight: 600; font-size: 14px; color: #fff; cursor: pointer; }
.sz-sched-btn-confirm:hover { background: #2E7D32; }
</style>

<style>
/* Dark mode */
.dark .sz-sched-modal { background: #1F2125; }
.dark .sz-sched-header { border-bottom-color: #363840; color: #EDEEEF; }
.dark .sz-sched-close { color: #6B7280; }
.dark .sz-sched-desc { color: #9CA3AF; }
.dark .sz-sched-field label { color: #EDEEEF; }
.dark .sz-sched-field input { background: #111214; border-color: #363840; color: #EDEEEF; }
.dark .sz-sched-footer { border-top-color: #363840; }
.dark .sz-sched-btn-cancel { border-color: #363840; color: #D4D4D4; }
.dark .sz-sched-btn-cancel:hover { background: #363840; }
.dark .sz-sched-error { background: #2a1515; color: #f87171; }
</style>
